export enum MergeLogicTypes {
  latest = 'latest',
  first = 'first',
}
